import React, { useEffect, useState } from "react";
import { Alert, Grid } from "@mui/material";
import { AppAutocomplete } from "components/common/inputs";
import { AppButton } from "components/common/buttons";
import { getContractItemTypes, getContractProvinces } from "../../services/contractItemStructure.service";

export const defaultItemStructure = () => ({ itemTypes: ["ESTIMATE"], provinceId: null, communeIds: [] });
export const hasGeographicItems = (value) => value.itemTypes.some((type) => type !== "ESTIMATE");
export const validateItemStructure = (value) => !value.itemTypes.length ? "Phải chọn ít nhất một loại hạng mục." : null;

export default function ContractItemStructureFields({ open, value, onChange, onReady, error, disabled, showTypes = true }) {
  const [types, setTypes] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lookupError, setLookupError] = useState("");
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!open) return;
    let active = true;
    setLoading(true);
    setLookupError("");
    Promise.all([showTypes ? getContractItemTypes() : Promise.resolve([]), getContractProvinces()])
      .then(([options, rows]) => {
        if (!active) return;
        if (showTypes && !options.length) throw new Error("Empty item types");
        setTypes(options);
        setProvinces(rows);
      }).catch(() => { if (active) setLookupError("Không thể tải danh mục loại hạng mục hoặc tỉnh/thành phố. Vui lòng thử lại."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open, showTypes, retry]);
  useEffect(() => { onReady(open && !loading && !lookupError); }, [open, loading, lookupError, onReady]);
  return <>
    {showTypes && <Grid size={{ xs: 12, sm: 6 }}>
      <AppAutocomplete label="Loại hạng mục" multiple required options={types} value={value.itemTypes}
        disabled={disabled || loading} error={!!error} helperText={error || "Có thể chọn nhiều loại hạng mục cùng lúc."}
        onChange={(itemTypes) => onChange({ ...value, itemTypes, communeIds: [] })} />
    </Grid>}
    <Grid size={showTypes ? { xs: 12, sm: 6 } : 12}>
      <AppAutocomplete label="Tỉnh/thành phố" value={value.provinceId || ""}
        options={provinces.map((row) => ({ value: row.provinceId, label: row.provinceName }))}
        disabled={disabled || loading}
        onChange={(provinceId) => onChange({ ...value, provinceId: provinceId ? Number(provinceId) : null, communeIds: [] })} />
    </Grid>
    {lookupError && <Grid size={12}><Alert severity="error" action={<AppButton disabled={disabled} onClick={() => setRetry((current) => current + 1)}>Thử lại</AppButton>}>{lookupError}</Alert></Grid>}
  </>;
}
